import styled from "styled-components";

const Text = styled.p`
  ${({ theme }) => theme.media.not_sm`
    margin: 10px 0 25px 0;
  `};
`;

export default Text;
